import usePluginEntities from "hooks/usePluginEntities";
const usePluggableEntityCollectionGranteeList = () => {
  var _a, _b;
  const pluggableCollectionGranteeList = usePluginEntities("components.collection");
  return (_b = (_a = pluggableCollectionGranteeList == null ? void 0 : pluggableCollectionGranteeList[0]) == null ? void 0 : _a.CollectionGranteeList) != null ? _b : null;
};
export default usePluggableEntityCollectionGranteeList;
